
import React from 'react';
import * as DialogPrimitive from "@radix-ui/react-dialog";

interface DialogProviderProps {
  children: React.ReactNode;
}

export function DialogProvider({ children }: DialogProviderProps) {
  return (
    <DialogPrimitive.Root>
      {children}
    </DialogPrimitive.Root>
  );
}
